import React, { useEffect, useState } from 'react';
import { KeyRound, Save, Link2, Loader2, CheckCircle } from 'lucide-react';
import { useApi } from './DashboardLayout';

export default function ApiKeysPage() {
  const { apiFetch } = useApi();
  const [googleKey, setGoogleKey] = useState('');
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch('/api/settings/api-keys').then(r => r?.json()).then(d => {
      if (d) setGoogleKey(d.google_maps_api_key || '');
      setLoading(false);
    });
  }, []);

  const handleSave = async () => {
    setSaving(true); setSaved(false);
    await apiFetch('/api/settings/api-keys', {
      method: 'POST',
      body: JSON.stringify({ google_maps_api_key: googleKey })
    });
    setSaving(false); setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  return (
    <div data-testid="api-keys-page">
      <div className="page-header">
        <h2>API-Schlüssel</h2>
        <p>Externe API-Schlüssel für Drittanbieter-Dienste verwalten.</p>
      </div>

      <div className="card">
        <div className="card-header" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <KeyRound size={18} style={{ color: 'var(--primary)' }} />
          <h3>Google Maps</h3>
        </div>
        <div className="card-body">
          {loading ? (
            <div className="empty-state"><Loader2 size={24} className="spin" /></div>
          ) : (
            <>
              <div style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: '1rem', lineHeight: 1.6 }}>
                Der Google Maps API-Key wird für die Adressvalidierung bei der Angebotserfassung verwendet. 
                Er stellt sicher, dass Sportstätten-Adressen korrekt sind und in der Herzgruppensuche gefunden werden.
              </div>
              <div className="form-group">
                <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  API-Key
                  <a href="https://console.cloud.google.com/apis/credentials" target="_blank" rel="noopener noreferrer"
                    style={{ fontSize: 12, color: 'var(--primary)', display: 'inline-flex', alignItems: 'center', gap: 3 }}>
                    <Link2 size={11} /> Google Cloud Console
                  </a>
                </label>
                <input
                  className="form-input"
                  value={googleKey}
                  onChange={e => setGoogleKey(e.target.value)}
                  placeholder="AIzaSy..."
                  style={{ fontFamily: 'monospace', fontSize: 13 }}
                  data-testid="google-maps-key-input"
                />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: '1rem' }}>
                <button className="btn btn-primary" onClick={handleSave} disabled={saving} data-testid="api-keys-save-btn">
                  {saving ? <><Loader2 size={14} className="spin" /> Speichern...</> : <><Save size={14} /> Speichern</>}
                </button>
                {saved && (
                  <span style={{ fontSize: 13, color: '#16a34a', display: 'flex', alignItems: 'center', gap: 4 }}>
                    <CheckCircle size={14} /> Gespeichert
                  </span>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
